import { ActionsUnion, IProviderServiceLevel } from '../../../types'
import * as constants from '../../constants'
import { createAction } from '../helpers'
import { globalSettingsService } from '../../../services/GlobalSettings'

export type IGlobalSettingsAction = ActionsUnion<typeof actionCreators>

export const actionCreators = {
  fetchServiceLevelsRequest: () => createAction(constants.GS_FETCH_SERVICE_LEVELS_REQUEST),
  fetchServiceLevelsSuccess: (serviceLevels: IProviderServiceLevel[]) =>
    createAction(constants.GS_FETCH_SERVICE_LEVELS_SUCCESS, serviceLevels),
  fetchServiceLevelsFail: (error: string) => createAction(constants.GS_FETCH_SERVICE_LEVELS_FAIL, error),
  createServiceLevelRequest: () => createAction(constants.GS_CREATE_SERVICE_LEVEL_REQUEST),
  createServiceLevelSuccess: (serviceLevel: IProviderServiceLevel) =>
    createAction(constants.GS_CREATE_SERVICE_LEVEL_SUCCESS, serviceLevel),
  createServiceLevelFail: (error: string) => createAction(constants.GS_CREATE_SERVICE_LEVEL_FAIL, error)
}

export const fetchServiceLevels = () => (dispatch: any) => {
  const { fetchServiceLevelsRequest, fetchServiceLevelsSuccess, fetchServiceLevelsFail } = actionCreators

  dispatch(fetchServiceLevelsRequest())
  return globalSettingsService
    .fetchServiceLevels()
    .then((serviceLevels: IProviderServiceLevel[]) => {
      dispatch(fetchServiceLevelsSuccess(serviceLevels))
    })
    .catch((res: any) => {
      dispatch(fetchServiceLevelsFail(res.data))
    })
}

export const createServiceLevel = (serviceLevel: { name: string }) => (dispatch: any) => {
  const { createServiceLevelRequest, createServiceLevelSuccess, createServiceLevelFail } = actionCreators

  dispatch(createServiceLevelRequest())
  return globalSettingsService
    .createServiceLevel(serviceLevel)
    .then((serviceLevel: IProviderServiceLevel) => {
      dispatch(createServiceLevelSuccess(serviceLevel))
    })
    .catch((res: any) => {
      dispatch(createServiceLevelFail(res.data))
    })
}



// WEBPACK FOOTER //
// ./src/state/actions/global-settings/index.ts